import { ajax } from 'utils';
// @ts-ignore
import _ from 'lodash';
import { QueryField } from 'modules/types/commons/Query';
import { WorkBenchMenuKey } from '../types/workbench';

export const LOADING = 'mpc/external/bidWorkbench/list_loading';
export const GET_LIST_SUCCESS = 'mpc/external/bidWorkbench/get_list_success';
export const GET_LIST_OPTIONS_SUCCESS =
  'mpc/external/bidWorkbench/get_list_options_success';
export const CHANGE_CONDITIONS = 'mpc/external/bidWorkbench/change_conditions';
export const CHANGE_CHECK = 'mpc/external/bidWorkbench/change_check';
export const CHANGE_LIST_FINISH_TYPE =
  'mpc/external/bidWorkbench/change_list_finish_type';

export interface GetListSuccess extends WorkBenchMenuKey {
  type: typeof GET_LIST_SUCCESS;
  data?: any;
}

export interface GetListOptionsSuccess extends WorkBenchMenuKey {
  type: typeof GET_LIST_OPTIONS_SUCCESS;
  data?: QueryField[];
}

export interface ChangeConditions extends WorkBenchMenuKey {
  type: typeof CHANGE_CONDITIONS;
  data?: any;
}

export interface Loading extends WorkBenchMenuKey {
  type: typeof LOADING;
}

export interface ChangeCheck extends WorkBenchMenuKey {
  type: typeof CHANGE_CHECK;
  data?: any;
}

export interface ChangeListFinishType extends WorkBenchMenuKey {
  type: typeof CHANGE_LIST_FINISH_TYPE;
  data?: any;
}

export type WorkbenchActions =
  | GetListSuccess
  | Loading
  | GetListOptionsSuccess
  | ChangeConditions
  | ChangeCheck
  | ChangeListFinishType;

export function changeCheck(menuKey: string, data: any) {
  return {
    type: CHANGE_CHECK,
    data: { menuKey, data },
    menuKey,
  };
}

export function changeConditions(conditions: any = {}) {
  return {
    type: CHANGE_CONDITIONS,
    data: conditions,
  };
}

export function getList(
  menuKey: string,
  conditions: any = {},
  pagination: any = {}
) {
  return {
    types: [LOADING, GET_LIST_SUCCESS, null],
    promise: () =>
      ajax({
        url: `outsource/v2/java_proxy/bidding/workbenches/list`,
        method: 'POST',
        body: {
          conditions,
          current: pagination.current_page,
          size: pagination.page_size,
          bidding_process_stage: _.snakeCase(menuKey).toUpperCase(),
        },
      }).then((res: any) => {
        return { data: { list: res.data, conditions, menuKey } };
      }),
    menuKey,
  };
}

export function getFilterOptions(menuKey: string, keys: string[]) {
  return {
    types: [null, GET_LIST_OPTIONS_SUCCESS, null],
    promise: () =>
      ajax({
        url: 'outsource/v2/java_proxy/common/filter_options',
        // url: 'v1/common/filter_options',
        method: 'POST',
        body: {
          keys,
          group_type: 'CHANNEL_GROUP',
          demand_state: 'TO_DO_PROCESS',
          // state: _.snakeCase(menuKey),
          // state: '',
          // data: keys.reduce((prev: any, curr: string) => {
          //   prev[curr] = { out: true };
          //   return prev;
          // }, {}),
        },
      }),
    menuKey,
  };
}

export function changeListFinishType(data: any) {
  return {
    type: CHANGE_LIST_FINISH_TYPE,
    data,
  };
}
